export const CLASSIC_SURVEY_BLOCK_IDS = [0, 1, 2, 3, 4, 5, 6, 7];

export const CLASSIC_SURVEY_EXPECTED_FIELDS = {
  0: [
    "blocImage",
    "temperatureSoil",
    "temperatureAmbient",
    "daysSinceRain",
    "comments",
    "temperatureSoilImage",
    "temperatureAmbientImage",
    "daysSinceRainImage",
    "commentsImage",
  ],
  1: ["soilType", "soilImage", "phLevel", "phImage", "phCategory", "comments", "commentsImage"],
  2: [
    "vegetation",
    "vegetationImage",
    "plantBool",
    "plantImage",
    "plantType",
    "treeBool",
    "treeImage",
    "treeType",
    "restBool",
    "restImage",
    "restType",
  ],
  3: ["rockBool", "rockCategory", "rockImage", "mineralBool", "mineralCategory", "mineralImage"],
  4: ["animalBool", "animalCategory", "animalImage"],
  5: ["wasteObserved", "wasteCategory", "blocImage"],
  6: ["fungiBool", "fungiType", "lichenBool", "lichenType", "bacteriaBool", "bacteriaType", "fungiImage", "bacteriaImage"],
  7: [
    "waterBool",
    "waterSource",
    "waterFlow",
    "waterMovement",
    "waterColor",
    "waterTransparency",
    "waterTransparencyLevel",
    "waterTemperature",
    "waterTemperatureCategory",
    "waterPH",
    "waterPHCategory",
    "aquaticAnimalBool",
    "aquaticAnimalCategory",
    "aquaticPlantBool",
    "aquaticPlantCategory",
    "photoWaterSource",
    "photoWaterFlow",
    "photoWaterColor",
    "photoWaterTransparency",
    "photoWaterTemperature",
    "photoWaterPH",
    "photoAquaticAnimal",
    "photoAquaticPlant",
    "photoWaterBool",
  ],
};

export function shouldCountClassicSurveyField(field) {
  const lower = String(field || "").toLowerCase();
  return !lower.endsWith("image") && !lower.startsWith("photo");
}

export function isClassicSurveyFieldFilled(blockId, field, value) {
  if (value == null) return false;
  if (blockId === 0) {
    if (field === "blocImage" && value === "/images/None") return false;
    if (["temperatureSoil", "temperatureAmbient", "daysSinceRain"].includes(field) && Number(value) === 0) {
      return false;
    }
  }
  if (Array.isArray(value)) return value.length > 0;
  return typeof value === "string" ? value.trim() !== "" : true;
}

export function isClassicSurveyBlockComplete(blockId, blockData = {}) {
  if (!blockData || typeof blockData !== "object" || Object.keys(blockData).length === 0) return false;
  const fields = (CLASSIC_SURVEY_EXPECTED_FIELDS[blockId] || []).filter(shouldCountClassicSurveyField);
  return fields.length > 0 && fields.every((field) => isClassicSurveyFieldFilled(blockId, field, blockData[field]));
}

export function getClassicSurveyContiguousCompletedBlocks(survey = {}) {
  const completed = [];
  for (const blockId of CLASSIC_SURVEY_BLOCK_IDS) {
    if (!isClassicSurveyBlockComplete(blockId, survey?.[`bloc${blockId}`] || {})) break;
    completed.push(blockId);
  }
  return completed;
}

export function getClassicSurveyProgress(survey = {}) {
  const completedBlocks = getClassicSurveyContiguousCompletedBlocks(survey);
  const nextIncompleteBlockId = completedBlocks.length < CLASSIC_SURVEY_BLOCK_IDS.length
    ? CLASSIC_SURVEY_BLOCK_IDS[completedBlocks.length]
    : null;
  const unlockedBlocks = CLASSIC_SURVEY_BLOCK_IDS.filter(
    (blockId, index) => index === 0 || completedBlocks.includes(blockId) || blockId === nextIncompleteBlockId
  );

  return {
    completedBlocks,
    completedCount: completedBlocks.length,
    totalBlocks: CLASSIC_SURVEY_BLOCK_IDS.length,
    percentage: (completedBlocks.length / CLASSIC_SURVEY_BLOCK_IDS.length) * 100,
    nextIncompleteBlockId,
    resumeBlockId: nextIncompleteBlockId ?? CLASSIC_SURVEY_BLOCK_IDS[0],
    unlockedBlocks,
    blockProgress: CLASSIC_SURVEY_BLOCK_IDS.reduce((acc, blockId) => {
      acc[blockId] = completedBlocks.includes(blockId) ? 100 : 0;
      return acc;
    }, {}),
  };
}
